/**
 * 🔧 FIX 431 ERROR: Header size management utility
 * Prevents "Request Header Fields Too Large" by managing localStorage
 */

export const initHeaderCleanup = () => {
  // Clear localStorage on app startup
  clearLargeStorageData();
  
  // Monitor localStorage size periodically
  setInterval(checkLocalStorageSize, 60000); // Check every minute
};

export const clearLargeStorageData = () => {
  try {
    const maxSize = 512 * 1024; // 512 KB limit
    const essentialKeys = ['token', 'expirationTime', 'uname', 'usertype'];
    
    let totalSize = 0;
    const storageData = {};
    
    // Calculate total size
    Object.keys(localStorage).forEach(key => {
      const value = localStorage.getItem(key);
      const size = value ? value.length : 0;
      totalSize += size;
      storageData[key] = size;
    });
    
    console.log(`📊 localStorage size: ${(totalSize / 1024).toFixed(2)} KB`);
    
    // If exceeds limit, remove non-essential data
    if (totalSize > maxSize) {
      console.warn(`⚠️ localStorage exceeds ${(maxSize / 1024).toFixed(0)} KB limit. Cleaning up...`);
      
      // Sort by size to remove largest items first
      const sortedKeys = Object.keys(storageData)
        .sort((a, b) => storageData[b] - storageData[a]);
      
      for (const key of sortedKeys) {
        if (!essentialKeys.includes(key) && totalSize > maxSize) {
          const itemSize = storageData[key];
          localStorage.removeItem(key);
          totalSize -= itemSize;
          console.log(`🗑️  Removed: ${key} (${(itemSize / 1024).toFixed(2)} KB)`);
        }
      }
    }
  } catch (e) {
    console.error('❌ Error managing localStorage:', e);
  }
};

export const checkLocalStorageSize = () => {
  try {
    let totalSize = 0;
    Object.keys(localStorage).forEach(key => {
      totalSize += localStorage.getItem(key)?.length || 0;
    });
    
    if (totalSize > 1024 * 1024) { // 1 MB
      console.warn(`⚠️ localStorage size critical: ${(totalSize / 1024 / 1024).toFixed(2)} MB`);
      clearLargeStorageData();
    }
  } catch (e) {
    console.error('Error checking localStorage size:', e);
  }
};

/**
 * Manually clean specific key types for testing
 */
export const clearStoragePattern = (pattern) => {
  try {
    const regex = new RegExp(pattern, 'i');
    const keysToRemove = Object.keys(localStorage).filter(key => regex.test(key));
    keysToRemove.forEach(key => localStorage.removeItem(key));
    console.log(`✅ Cleared ${keysToRemove.length} localStorage items matching: ${pattern}`);
  } catch (e) {
    console.error('Error clearing storage pattern:', e);
  }
};
